import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";

import { Box, Typography } from "@mui/material";

import TabsField from "components/Tab";
import MainCard from "components/cards/MainCard";
import Loader from "components/Loader";

import useZustandStore from "zustandStore";

import Overview from "./Overview";
import ServiceExperience from "./ServiceExperience";
import Security from "./Security";
import Roam from "./Roam";
import WirelessCoverage from "./WirelessCoverage";
import LinkIntegrity from "./LinkIntegrity";
import Operations from "./Operations";

import { ReactComponent as DisplayCalendarIcon } from "assets/images/icons/icn_display_calendar.svg";

const tabData = [
  {
    name: "Overview",
    value: "overview",
    disabled: null,
  },
  {
    name: "Service Experience",
    value: "service_experience",
    disabled: null,
  },
  {
    name: "Security",
    value: "security",
    disabled: null,
  },
  {
    name: "Roam",
    value: "roam",
    disabled: null,
  },
  {
    name: "Wireless Coverage",
    value: "wireless_coverage",
    disabled: null,
  },
  {
    name: "Link Integrity",
    value: "link_integrity",
    disabled: null,
  },
  {
    name: "Operations",
    value: "operations",
    disabled: null,
  },
];

const AInsight = () => {
  const navigate = useNavigate();
  const { scopeReady } = useOutletContext();
  const { serviceStatus } = useZustandStore();

  useEffect(() => {
    if (scopeReady && serviceStatus && !serviceStatus.services?.healthAI) {
      navigate(-1);
    }
  }, [scopeReady, serviceStatus, navigate]);

  const [tabVal, setTabVal] = useState("overview");
  const [timeRange, setTimeRange] = useState("Last 7 Days");

  if (!scopeReady) return <Loader />;

  function handleTab(_event, newValue) {
    setTabVal(newValue);
  };

  const aInsightFieldMap = {
    overview: <Overview timeRange={timeRange} handleTab={handleTab}/>,
    service_experience: <ServiceExperience />,
    security: <Security />,
    roam: <Roam />,
    wireless_coverage: <WirelessCoverage />,
    link_integrity: <LinkIntegrity />,
    operations: <Operations />,
  };

  return (
    <>
      {/* <Box sx={{ display: "flex", alignItems: "center", position: "absolute", top: "10px", right: "25px" }}>
        <DisplayCalendarIcon />
        <Typography sx={{ marginLeft: "5px" }}>{timeRange}</Typography>
      </Box> */}
      <MainCard>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <TabsField
            tabVal={tabVal}
            handleTabsChange={handleTab}
            tabData={tabData}
          />
        </Box>
        <Typography sx={{ color: "#000000", margin: "20px 20px 0 20px" }}>
          This feature is currently available for evaluation and may require a license in future releases.
        </Typography>
        <Box sx={{ margin: "20px 20px" }}>
          {aInsightFieldMap[tabVal]}
        </Box>
      </MainCard>
    </>
  );
};

export default AInsight;
